var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
/**
 * @deprecated utiliser `Input`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var InputMi = React.forwardRef(function (_a, ref) {
    var name = _a.name, label = _a.label, texteAide = _a.texteAide, disabled = _a.disabled, _b = _a.type, type = _b === void 0 ? "text" : _b, required = _a.required, displayRequired = _a.displayRequired, icone = _a.icone, longueurMax = _a.longueurMax, boutonAction = _a.boutonAction, uppercase = _a.uppercase, maskFonction = _a.maskFonction, onChange = _a.onChange, onBlur = _a.onBlur, error = _a.error, warning = _a.warning, valid = _a.valid, className = _a.className, append = _a.append, otherProps = __rest(_a, ["name", "label", "texteAide", "disabled", "type", "required", "displayRequired", "icone", "longueurMax", "boutonAction", "uppercase", "maskFonction", "onChange", "onBlur", "error", "warning", "valid", "className", "append"]);
    var ChampsTag = "input";
    if (type === 'textarea') {
        ChampsTag = type;
    }
    var texteValidation = undefined;
    var inputGroupClassName = "fr-input-group dsmi-input-group";
    var inputClassName = className + " fr-input";
    if (disabled) {
        inputGroupClassName += " fr-input-group--disabled";
        inputClassName += " fr-input--disabled";
    }
    else if (error) {
        inputGroupClassName += " fr-input-group--error";
        inputClassName += " fr-input--error";
        if (typeof error === 'object' && "message" in error && error.message) {
            texteValidation = {
                id: "".concat(name, "-desc-error"),
                message: error.message,
                className: "fr-error-text",
            };
        }
    }
    else if (warning) {
        inputGroupClassName += " fr-input-group--warning";
        inputClassName += " fr-input--warning";
        if (typeof warning === 'object' && "message" in warning && warning.message) {
            texteValidation = {
                id: "".concat(name, "-desc-warning"),
                message: warning.message,
                className: "fr-warning-text",
            };
        }
    }
    else if (valid) {
        inputGroupClassName += " fr-input-group--valid";
        inputClassName += " fr-input--valid";
        if (typeof valid === 'object' && "message" in valid && valid.message) {
            texteValidation = {
                id: "".concat(name, "-desc-valid"),
                message: valid.message,
                className: "fr-valid-text",
            };
        }
    }
    if (displayRequired || required && displayRequired !== false) {
        inputGroupClassName += " required";
    }
    var onChangeSurcharge = function (event) {
        var value = event.target.value;
        var selectionStart = event.target.selectionStart;
        if (!selectionStart) {
            selectionStart = 0;
        }
        if (uppercase) {
            event.target.value = "".concat(value).toUpperCase();
        }
        if (maskFonction) {
            var valueMasked = maskFonction(value);
            selectionStart = selectionStart + valueMasked.length - value.length;
            event.target.value = valueMasked;
        }
        if (type && ["password", "search", "tel", "text", "url", "textarea"].includes(type)) {
            event.target.setSelectionRange(selectionStart, selectionStart);
        }
        if (onChange) {
            onChange(event);
        }
    };
    var styleGroup = {};
    if (longueurMax) {
        styleGroup = { width: '100%', maxWidth: longueurMax };
    }
    var renduChamp = useMemo(function () {
        var champsTag = React.createElement(ChampsTag
        // @ts-ignore
        , __assign({ 
            // @ts-ignore
            ref: ref, id: name, name: name, type: type, onChange: onChangeSurcharge, onBlur: onBlur, className: inputClassName, disabled: disabled, required: required }, otherProps, { "aria-describedby": texteValidation && texteValidation.id }));
        if (type === 'textarea') {
            return champsTag;
        }
        if (icone) {
            champsTag = (React.createElement("div", { className: "fr-input-wrap ".concat(icone) }, champsTag));
        }
        if (boutonAction) {
            return (React.createElement("div", { className: "fr-input-wrapBouton" },
                champsTag,
                boutonAction));
        }
        return champsTag;
    }, [ref, name, type, onChangeSurcharge, onBlur, inputClassName, disabled, required, otherProps, texteValidation]);
    return (React.createElement("div", { className: inputGroupClassName, style: styleGroup },
        React.createElement("label", { className: "fr-label", htmlFor: name },
            React.createElement("span", { className: "fr-label-texte" }, label),
            texteAide && React.createElement("span", { className: "fr-hint-text" }, texteAide)),
        renduChamp,
        append,
        texteValidation && (React.createElement("p", { id: texteValidation.id, className: texteValidation.className }, texteValidation.message))));
});
export default InputMi;
